
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorPage',
  props: {
    errorState: {
      type: Object,
      required: true,
    },
  },
})
